import { ReactElement } from 'react';
import { useLogger } from 'core/common/hooks';
import { Locales } from 'core/user/entities';
import { useUserLocation } from 'core/user/hooks';

interface LocationProps {
  children: ReactElement[] | ReactElement;
}

export const Location = ({ children }: LocationProps) => {
  const { locale: userLocale } = useUserLocation();
  const logger = useLogger();

  const getUserLocationFromArray = (childrenArray: ReactElement[]): ReactElement | null => {
    if (!childrenArray.some(({ props }) => props.option === Locales.OTHER)) {
      logger.warn(
        'You should create LocationOption component with option="OTHER" as default location',
      );
    }

    const currentLocale = childrenArray.find(
      ({ props }) =>
        !!(
          (typeof props.option === 'string' && props.option === userLocale) ||
          (Array.isArray(props.option) && props.option.some((item: string) => item === userLocale))
        ),
    );

    return (
      currentLocale || childrenArray.find(({ props }) => props.option === Locales.OTHER) || null
    );
  };

  const getCorrectUserLocation = (child: ReactElement) => {
    if (!child.props.option) {
      logger.warn('The Location component should contain one or more LocationOption components');
      return null;
    }
    if (child.props.option === userLocale) return <>{child}</>;
    return null;
  };

  const child = Array.isArray(children)
    ? getUserLocationFromArray(children)
    : getCorrectUserLocation(children);

  return <>{child}</>;
};
